import { UserInfo } from '@/types';
import { httpServices } from '../axiosClient';

export const getUsersByIds = async (data: any) => {
  return await httpServices.llmService.post<any>(
    '/organization/members/ids',
    data,
  );
};

export const getUserInfo = async (): Promise<UserInfo | null> => {
  try {
    const response = await httpServices.saasService.get<{ success: boolean; data: UserInfo }>('/saas/me/info');
    if (response?.success && response?.data) {
      return response.data;
    }
    return null;
  } catch (e) {
    return null;
  }
};
